export default "__VITE_ASSET__CgCfRrMt__"